import ArabicToEthiopic from './ArabicToEthiopic';
import * as workerTimers from 'worker-timers';
import './styles/style.css';
import zero from './assets/0.svg';
const $ = (selector) => document.getElementById(selector);
const $cl = (cl) => document.getElementsByClassName(cl)[0];
let on = (el, ev, cb) => el.addEventListener(ev, cb);

const clearInt = i => i && workerTimers.clearInterval(i);
const padZero = (x) => x < 10 ? `0${x}:` : `${x}:`;

var hr = 0
var min = 0
var sec = 0
var mil = 0
var countDown = 0

let clockInterval = null;
let timerInterval = null;
var stopwatchInterval = null
let hovered = false;

let stopWatchSection = $('stopwatch');
let timerSection = $('timer');
let clockSection = $('clock');

var $mil = $('mil')
var $sec = $('sec')
var $min = $('min')
var $hr = $('hr')

// : Separators
var hrSep = $cl('hrSep')
var minSep = $cl('minSep')
var secSep = $cl('secSep')

let phs = document.getElementsByClassName('ph');
for (let img of phs) {
    img.setAttribute("src", zero);
}

function switchPlaceHolder(time, sep, ph, el) {
    if (time === 0) {
        sep.style.display = 'inline'
        ph.style.display = 'inline'
        el.style.display = 'none';
    }
    else {
        sep.style.display = 'none';
        ph.style.display = 'none'
        el.style.display = 'inline';
        el.textContent = `${ArabicToEthiopic(time)}፡`
    }
}

const hide = el => $(el).classList.add('hide');
const show = el => $(el).classList.remove('hide');


const toggle = (hideEl, showEl) => {
    hide(hideEl);
    show(showEl);
}

// CSS `:hover` gets stuck "on" after a tap on touch devices (no real pointer to
// move away), which desyncs the Arial font swap from the actual `hovered`
// state. Drive the font swap from JS instead so it can never fall out of sync
// with the numeral text it's meant to accompany.
const hoverIn = (cl, cb) => on($cl(cl), 'pointerenter', () => { hovered = true; $cl(cl).classList.add('reveal'); cb && cb(); })
const hoverOut = (cl, cb) => on($cl(cl), 'pointerleave', () => { hovered = false; $cl(cl).classList.remove('reveal'); cb && cb(); })

hoverIn('sWatch', stopWatch)
hoverOut('sWatch', stopWatch)


function stopWatch() {
    // Placeholders
    var hrPh = $cl('swHrPh');
    var minPh = $cl('swMinPh');
    var secPh = $cl('swSecPh');
    var milPh = $cl('swMilPh');

    if (hovered) {
        [$hr, $min, $sec, $mil].forEach(e => e.style.display = 'inline');
        [secPh, minPh, hrPh, milPh].forEach(e => e.style.display = 'none');
        [secSep, minSep, hrSep].forEach(e => e.style.display = 'none');

        $hr.textContent = padZero(hr);
        $min.textContent = padZero(min);
        $sec.textContent = padZero(sec);
        $mil.textContent = mil < 10 ? `0${mil}` : mil;

    } else {
        if (mil === 0) {
            milPh.classList.add('solid');
            milPh.style.display = 'inline'
            $mil.style.display = 'none';
        }
        else {
            milPh.style.display = 'none'
            $mil.style.display = 'inline';
            $mil.textContent = `${ArabicToEthiopic(mil)}`
        }

        switchPlaceHolder(sec, secSep, secPh, $sec);
        switchPlaceHolder(min, minSep, minPh, $min);
        switchPlaceHolder(hr, hrSep, hrPh, $hr);
    }
}

function startSw() {
    if (stopwatchInterval) return
    stopwatchInterval = workerTimers.setInterval(() => {
        mil += 10

        if (mil == 100) {
            mil = 0
            sec++
        }

        //5
        if (sec == 60) {
            sec = 0
            min++
        }

        //3
        if (min == 60) {
            min = 0
            hr++
        }

        // if(sec === 0) sec++
        stopWatch()

    }, 100)
}

function pauseSw() {
    clearInt(stopwatchInterval)
    stopwatchInterval = null
}

function resetSw() {
    pauseSw()
    min = sec = mil = hr = 0
    stopwatchInterval = null
    stopWatch()
    $cl('swMilPh').classList.remove('solid');
}

// Timer Section
function renderTimerDisplay() {
    if (countDown < 0) return;

    // Placeholders
    var hrPh = $cl('hrPh');
    var minPh = $cl('minPh');
    var secPh = $cl('secPh');
    var milPh = $cl('milPh');

    // Countdown
    let timerHr = $('timerHr')
    let timerMin = $('timerMin')
    let timerSec = $('timerSec')
    let timerMil = $('timerMil')

    // Separators
    var timerHrSep = $cl('timerHrSep');
    var timerMinSep = $cl('timerMinSep');
    var timerSecSep = $cl('timerSecSep');

    let mil = (Math.round((countDown / 10) % 100) % 100)
    let seconds = ((Math.floor((countDown / 1000) % 60) % 60))
    let minutes = (Math.floor((countDown / 60000) % 60))
    let hours = (Math.floor(countDown / 3600000))

    if (hovered) {
        [timerHr, timerMin, timerSec, timerMil].forEach(e => e.style.display = 'inline');
        [secPh, minPh, hrPh, milPh].forEach(e => e.style.display = 'none');
        [timerSecSep, timerMinSep, timerHrSep].forEach(e => e.style.display = 'none');

        timerHr.textContent = padZero(hours);
        timerMin.textContent = padZero(minutes);
        timerSec.textContent = padZero(seconds);
        timerMil.textContent = mil < 10 ? `0${mil}` : mil;

    } else {
        if (mil === 0) {
            milPh.classList.add('solid');
            milPh.style.display = 'inline'
            timerMil.style.display = 'none';
        }
        else {
            milPh.style.display = 'none'
            timerMil.style.display = 'inline';
            timerMil.innerHTML = `${ArabicToEthiopic(mil)}`
        }

        switchPlaceHolder(seconds, timerSecSep, secPh, timerSec);
        switchPlaceHolder(minutes, timerMinSep, minPh, timerMin);
        switchPlaceHolder(hours, timerHrSep, hrPh, timerHr);
    }
}

hoverIn('timerView', renderTimerDisplay)
hoverOut('timerView', renderTimerDisplay)

const timer = () => {
    // Timer input
    let hrInput = $('hrInput').value;
    let minInput = $('minInput').value;
    let secInput = $('secInput').value;

    toggle('initTimer', 'startTimer');

    $cl('timerEdit').classList.toggle('hide');
    $cl('timerView').classList.toggle('hide');
    countDown = secInput * 1000 + minInput * 60000 + hrInput * 3600000;

    const startTimer = () => {
        timerInterval = workerTimers.setInterval(() => {
            if (countDown < 0) {
                $cl('milPh').classList.remove('solid');
                return;
            }

            renderTimerDisplay();
            countDown -= 100;
        }, 100);
    }

    // TODO: what is this?
    startTimer();

    on($('startTimer'), 'click', () => {
        toggle('startTimer', 'pauseTimer');
        startTimer();
    })

    on($('pauseTimer'), 'click', () => {
        clearInt(timerInterval)
        timerInterval = null;
        toggle('pauseTimer', 'startTimer');
    })

    on($('resetTimer'), 'click', () => {
        clearInt(timerInterval)
        countDown = 0;

        [$('hrInput'), $('minInput'), $('secInput')].forEach(e => e.value = '');
        hrInput = minInput = secInput = 0

        timerInterval = null;
        timer();

        toggle('startTimer', 'initTimer');
        toggle('pauseTimer', 'initTimer');
    })
}

hoverIn('clk', () => clock());
hoverOut('clk', () => clock());

const clock = () => {
    var curHr = $('curHr');
    var curMin = $('curMin');
    var curSec = $('curSec');
    var curSecPh = $cl('curSecPh')
    var curMinPh = $cl('curMinPh')

    stopWatchSection.classList.add('hide')
    timerSection.classList.add('hide');
    clockSection.classList.remove('hide');

    let clockSep = document.getElementsByClassName('clockSep');

    let date = new Date();
    let m = date.getMinutes();
    let s = date.getSeconds();

    function clockPlaceholder(time, ph, el) {
        if (time === 0) {
            ph.style.display = 'inline'
            el.style.display = 'none';
        }
        else {
            ph.style.display = 'none'
            el.style.display = 'inline';
            el.textContent = `${ArabicToEthiopic(time)}`
        }
    }

    if (hovered) {
        [curSecPh, curMinPh].forEach(e => e.style.display = 'none');
        for (let sep of clockSep) sep.style.display = 'none'

        curHr.textContent = `${date.getHours()}:`;
        curMin.textContent = m < 10 ? `0${m}:` : `${m}:`
        curSec.textContent = s < 10 ? `0${s}` : s;
    } else {
        for (let sep of clockSep) sep.style.display = 'inline'
        curHr.textContent = ArabicToEthiopic(date.getHours());

        clockPlaceholder(s, curSecPh, curSec)
        clockPlaceholder(m, curMinPh, curMin)
    }

}

const displayTimer = () => {
    timerSection.classList.remove('hide');
    stopWatchSection.classList.add('hide')
    clockSection.classList.add('hide')
    $cl('swControls').classList.add('hide')
    $cl('timerControls').classList.remove('hide');
    $('minInput').focus()
    show('controls');

    clearInt(clockInterval)
    clockInterval = null
}
const displayClock = () => {
    clock();
    hide('controls')
    if (!clockInterval) {
        clockInterval = workerTimers.setInterval(() => clock(), 100);
    }
}

const displayStopWatch = () => {
    clockSection.classList.add('hide');
    stopWatchSection.classList.remove('hide');
    timerSection.classList.add('hide');
    $cl('timerControls').classList.add('hide')
    $cl('swControls').classList.remove('hide');
    show('controls')

    clearInt(clockInterval)
    clockInterval = null
}

const setActiveMode = (activeId) => {
    ['displayStopWatch', 'displayTimer', 'displayClock'].forEach(id => {
        $(id).classList.toggle('is-active', id === activeId);
    });
}

$('displayStopWatch').onclick = () => { displayStopWatch(); setActiveMode('displayStopWatch'); };
$('displayTimer').onclick = () => { displayTimer(); setActiveMode('displayTimer'); };
$('displayClock').onclick = () => { displayClock(); setActiveMode('displayClock'); };

on($('startSw'), 'click', () => {
    startSw();
    toggle('startSw', 'pauseSw');
})

on($('pauseSw'), 'click', () => {
    pauseSw();
    toggle('pauseSw', 'startSw');
})

on($('resetSw'), 'click', () => {
    resetSw();
    toggle('pauseSw', 'startSw');
})

on($('initTimer'), 'click', () => {
    if (!$('hrInput').value &&
        !$('minInput').value &&
        !$('secInput').value)
        {$('minInput').focus();
            return;}

    timer();
    toggle('startTimer', 'pauseTimer');
})

on($('fullscreen'), 'click', () => {
    const getFullscreenElement = () => {
        return document.fullscreenElement
            || document.webkitFullscreenElement
            || document.mozFullscreenElement
            || document.msFullscreenElement;
    }

    if (getFullscreenElement()) document.exitFullscreen();
    else document.documentElement.requestFullscreen();
})

function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    });
}

const filterNum = els => els.map(el => setInputFilter(el, (value) => /^\d*\.?\d*$/.test(value)))
filterNum([$('hrInput'), $('minInput'), $('secInput')]);